
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useLang, setLanguage} from '../../../i18n/Metronici18n'

import { userService } from '@/core/services/user-service';
import { Config } from '@/core/config/config';
import { t } from 'i18next';
import { useAuth } from '@/modules/auth/core/Auth';

const languages = [
  {
    id:'09be94b4-b9f4-43c8-b432-cd89cb263032',
    lang: 'en',
    code:"en-US",
    name: 'English',
    flag: toAbsoluteUrl('media/flags/united-states.svg'),
  },
  {
    id:'2d57883e-b3fb-4edb-b8c8-569ae6e0051f',
    lang: 'tr',
    code:"tr-TR",
    name: 'Türkçe',
    flag: toAbsoluteUrl('media/flags/turkey.svg'),
  },
]



const Languages: FC = () => {
  const lang = useLang()
  
  const { refreshAuth } = useAuth();

  const updateLanguage = (languageId: any, langCode: any, lang: any) => {
    document.body.classList.add("page-loading");
    const splashScreen = document.getElementById('splash-screen')
    if (splashScreen) {
      splashScreen.style.setProperty('display', 'flex')
    }
    const params = { languageId: languageId };
    userService.updateUserLanguage(params).then(res => {
      if (res.status === 200) {
        refreshAuth().finally(()=>{
          localStorage.setItem(Config.VITE_APP_LANGUAGE_KEY, langCode);
          setLanguage(lang)
        })
      }
    });
  };
  
  const currentLanguage = languages.find((x) => x.lang === lang)
  return (
    <div
      className='menu-item px-5'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    >
      <a href='#' className='menu-link px-5'>
        <span className='menu-title position-relative'>
          {t('language')}
          <span className='fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
            {currentLanguage?.name}{' '}
            <img
              className='w-15px h-15px rounded-1 ms-2'
              src={currentLanguage?.flag}
              alt='metronic'
            />
          </span>
        </span>
      </a>

      <div className='menu-sub menu-sub-dropdown w-175px py-4'>
        {languages.map((l) => (
          <div
            className='menu-item px-3'
            key={l.lang}
            onClick={() => {
              updateLanguage(l.id, l.code, l.lang)
            }}
          >
            <a
              className={clsx('menu-link d-flex px-5', {active: l.lang === currentLanguage?.lang})}
            >
              <span className='symbol symbol-20px me-4'>
                <img className='rounded-1' src={l.flag} alt='metronic' />
              </span>
              {l.name}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export {Languages}
